import { Dimensions, Platform, StyleSheet } from 'react-native';
import { moderateScale } from 'react-native-size-matters';

import Theme from '../../theme';
import { defaultScale } from '../../utils';

const width = Dimensions.get('window').width;
const isMobile = width <= 550;

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 5,
  },
  containerNoPadding: {
    flex: 1,
  },
  warningContainer: {
    flex: 1,
    alignContent: 'center',
    alignSelf: 'center',
  },
  loadingContainer: {
    flex: 1,
    alignSelf: 'center',
  },
  verticalSeparator: {
    width: 2,
    marginHorizontal: 10,
    backgroundColor: Theme.GREY_LIGHT,
  },
  subtitleContainer: {
    width: '100%',
    flexDirection: 'row',
  },
  subtitleContainerWithDropDown: {
    width: '100%',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',
  },
  locationIconStyle: {
    alignSelf: 'center',
    margin: 5,
  },
  subtitle: {
    fontSize: moderateScale(14, 2),
    fontFamily: Theme.Custom500,
    color: Theme.CHARCOAL,
    alignSelf: 'center',
    ...Platform.select({
      android: {
        fontSize: moderateScale(12, 2),
        fontFamily: Theme.Custom500,
      },
    }),
  },
  footer: {
    flex: 1,
    paddingVertical: 10,
    justifyContent: 'flex-end',
  },
  leftButtonOverideStyle: {
    flex: isMobile ? 0.7 : 1,
  },
  rightButtonOverideStyle: {
    flex: isMobile ? 0.3 : 1,
  },
  recommendedContainer: {
    flexDirection: 'row',
    paddingVertical: 8,
    borderBottomWidth: 2,
    borderBottomColor: Theme.GREY_LIGHT,
  },
  updatedSettingsRow: {
    alignItems: 'center',
    justifyContent: 'center',
    height: 35,
  },
  body: {
    ...StyleSheet.absoluteFillObject,
    top: Dimensions.get('window').height / 5,
    alignItems: 'center',
  },
  heading: {
    textAlign: 'center',
    ...Theme.textStyle.heading,
    marginBottom: defaultScale(15),
  },
});
